import { HintTypeEnum } from '@nankai/online/constants';

export default {
  seat: {
    parenthesis: '（{{text}}）',
    header: {
      station: '請輸入訂購資訊',
      seat: '請選擇座位',
      start: '{{time}}出發',
      confirm: '座位確認',
      bookingConfirm: '※僅在支付完成且預訂完成後，座位才會正式確認。'
    },
    button: {
      back: '回退',
      next: '下一步',
      change: '變更'
    },
    confirmChange: {
      title: '您的預訂將變更如下。',
      before: '變更前',
      after: '變更後',
      label: {
        trainName: '列車',
        date: '日期',
        time: '時間',
        seat: '座位',
        seatWithCar: '座位（{{carNo}}號車廂）'
      }
    },
    selectSeatType: {
      title: '選位方法',
      auto: '電腦選位',
      manual: '自行選位'
    },
    station: {
      date: '乘車日',
      startStation: '出發站',
      endStation: '抵達站',
      startStationTip: '請選擇出發站',
      endStationTip: '請選擇抵達站'
    },
    hintType: {
      [HintTypeEnum.OutOfAvailableTerm]:
        '所選日期尚未開放預訂。（僅可預訂1個月內的車次。）',
      [HintTypeEnum.EndOfService]:
        '暫無可購買的列車。<br />請確認列車運行資訊。'
    },
    train: {
      header: '請選擇小火車',
      emptySeat: '空座位',
      trainLabel: '{{trainName}}{{trainServiceNo}}號'
    },
    carriage: {
      carriageCar: '{{carNo}}號車廂',
      directionUpTitle: '↑ 往難波方向',
      directionDownTitle: '↑ 往高野山方向',
      car1Notice1: '【請注意】2、4、23、27號為無窗座位。',
      car1Notice2: '由於乘務員室一側為牆壁，因此無法觀賞前方景色。'
    },
    wheelchairConfirm: {
      title: '您已選擇輪椅專用座位',
      content: '本座位為輪椅使用者專用座位。請確認以下事項：',
      notice1: '本座位僅供預計以輪椅前來的乘客使用。',
      notice2: '一般乘客請勿使用本座位。',
      confirmText: '是否要繼續選擇？',
      cancel: '取消',
      confirm: '確定'
    }
  },
  error: {
    invalidParams: '指定的條件有誤。請從頭重新操作',
    lineIdInvalid: '未選擇路線。請從頭重新操作',
    productIdInvalid: '選擇的車廂類型不正確。 請從頭開始重新操作',
    forbidden: '此操作不允許。請從頭重新操作',
    seatChangeCountExceeded: '座席變更次數限制為2次',
    notFound: '找不到頁面。請從頭重新操作',
    system: '系統錯誤。 請稍後再試'
  }
};
